import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/BonniePeterson/subs.vtt';
import poster from '@/static/assets/reviews/BonniePeterson/video.jpg';

export const BonniePeterson: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Bonnie',
  videoUrl: `${ASSETS_URL}/car/BonniePeterson_Car.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
